// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2tfLU","bigColWidth":"Table_bigColWidth__2nuv4","biggerColWidth":"Table_biggerColWidth__8Bwy8","row":"Table_row__3NcqO","col":"Table_col__1L7XW"};